import { render, staticRenderFns } from "./greetings.vue?vue&type=template&id=24d1c918&scoped=true&"
import script from "./greetings.vue?vue&type=script&lang=js&"
export * from "./greetings.vue?vue&type=script&lang=js&"
import style0 from "./greetings.vue?vue&type=style&index=0&id=24d1c918&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d1c918",
  null
  
)

export default component.exports